/* eslint-disable no-unused-vars */
import { errorActions } from "Features/error";
import { selectUser, userActions } from "Features/user";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";
import { getReqHeader, getReqHeaderFormData } from "Shared/helpers";
import { authActions } from "./auth.slice";

function* loginFetchWorker({ payload }) {
	let result = { token: "", user: null };
	try {
		const { data } = yield call(api.post, "/auth/local", payload);
		result = data;
	} catch (error) {
		console.error("loginFetchWorker", error.response.statusText);
		yield put(errorActions.set({ message: error.response.statusText, page: "login" }));
	} finally {
		yield put(authActions.response());
		yield put(userActions.set(result));
	}
}

function* logoutFetchWorker() {
	try {
		const headers = yield call(getReqHeader);
		yield call(api.get, "/logout", headers);
	} catch (error) {
		console.error("logoutFetchWorker", error);
	} finally {
		yield put(userActions.set({ token: "", user: null }));
		yield put(authActions.response());
	}
}

function* registerWorker({ payload }) {
	let result = { token: "", user: null };
	try {
		const headers = yield call(getReqHeader);
		const { data } = yield call(api.post, "/register/local", { ...payload, password2: payload.password }, headers);
		result = data;
	} catch (error) {
		console.error("registerWorker", error);
		yield put(errorActions.addError({ page: "register", error }));
	} finally {
		yield put(authActions.response());
		yield put(userActions.set(result));
	}
}

function* updateUserWorker({ payload }) {
	const token = yield select(selectUser.token);
	const oldUser = yield select(selectUser.data);
	let result = { token, user: oldUser };
	try {
		const headers = yield call(getReqHeaderFormData);
		const { data: user } = yield call(api.post, "/user/profile", payload, headers);
		result.user = user;
	} catch (error) {
		console.error("updateUserWorker", error);
		const message = error.response.data.message;
		yield put(errorActions.set({ message, page: "postreg" }));
	} finally {
		yield put(userActions.set(result));
		yield put(authActions.response());
	}
}

function* recoverPasswordWorker({ payload: email }) {
	try {
		const headers = yield call(getReqHeader);
		yield call(api.post, "/password/recovery.send", { email }, headers);
		yield put(authActions.succes(true));
	} catch (error) {
		console.error("recoverPawordWorker ", error);
		yield put(errorActions.addError({ page: "recover-pass", error }));
		yield put(authActions.succes(false));
	} finally {
		yield put(authActions.response());
	}
}

function* checkUserWorker() {
	let result = { token: "", user: null };
	let authSession;
	try {
		const token = yield select(selectUser.token);
		const { data: user } = yield call(api.get, "/user/profile");
		const { data } = yield call(api.get, "/auth-session");
		authSession = data;
		result = { token, user };
	} catch (error) {
		console.error("getUserWorker", error);
	} finally {
		yield put(authActions.response(authSession));
		yield put(userActions.set(result));
	}
}

function* setPass({ payload }) {
	const headers = yield call(getReqHeader);
	try {
		yield call(
			api.post,
			"/password/recovery.edit",
			{
				password: payload.password,
				password2: payload.password,
				token: payload.token,
			},
			headers,
		);
		yield put(authActions.succes(true));
	} catch (error) {
		yield put(errorActions.addError({ page: "set-pass", error }));
		yield put(authActions.succes(false));
	} finally {
		yield put(authActions.response());
	}
}

function* removeWorker({ payload = "" }) {
	try {
		yield call(api.post, "/user/profile.remove", { password: payload });
	} catch (error) {
		console.error("removeWorker", error);
	} finally {
		yield put(userActions.drop());
		yield put(authActions.response());
	}
}

export function* watchAuth() {
	yield takeEvery(authActions.login, loginFetchWorker);
	yield takeEvery(authActions.logout, logoutFetchWorker);
	yield takeEvery(authActions.register, registerWorker);
	yield takeEvery(authActions.update, updateUserWorker);
	yield takeEvery(authActions.recover, recoverPasswordWorker);
	yield takeEvery(authActions.check, checkUserWorker);
	yield takeEvery(authActions.remove, removeWorker);
	yield takeEvery(authActions.setPass, setPass);
}
